import ExceptionsView from '../Views/ExceptionsView.vue';

const ExceptionsRoute = [
  {
    path:'',
    component: ExceptionsView,
    meta: { name: 'Index', group: 'portaladministrativo.admission', path: 'exceptions', permission: 'READ' }
  }
]

export default ExceptionsRoute
